<script>
	// NPM Modules
	import { createEventDispatcher } from 'svelte';
	// Stores
	import { reviewPayoutBetId } from '@/Stores/Store.js';
	import BetReviewPayoutStore from '@/Stores/BetReviewPayoutStore.js';
	// Components
	import Modal from '@/Components/Modal.svelte';
	import LoadingButton from '@/Components/LoadingButton.svelte';
	import TextInput from '@/Components/NewTextInput.svelte';
	// Services
	import { notify } from '@/Services/Notify.js';
	// Constants
	import { ActionType } from '@/Constants/Rule.js';
	import { CurrencyFormat } from '@/Services/Helpers';

	const dispatch = createEventDispatcher();

	export let store;

	let sending = false;
	let open = false;
	let adjusted_amount = '';

	$: open = $reviewPayoutBetId;
	$: bet = open && $reviewPayoutBetId && store && store.firstWhere('id', $reviewPayoutBetId);
	$: bet && !adjusted_amount && setAdjustedAmount(bet.win_amount);
	$: rule = bet && bet.rules && bet.rules.data && bet.rules.data.firstWhere('rule_meta.type.id', ActionType.Result);

	function confirmClicked() {
		if (!parseFloat(adjusted_amount)) return;
		sending = true;
		BetReviewPayoutStore.approvePayout(bet.id, {
			adjusted_amount: parseFloat(adjusted_amount) * 100
		})
			.then(() => {
				notify({
					type: 'success',
					title: `Bet Ticket #${bet.ticket}`,
					message: `Bet Payout of $${adjusted_amount} confirmed.`,
					timeout: 3
				});
				dispatch('saved');
				onClose();
			})
			.catch((e) => {
				notify({
					type: 'danger',
					title: 'Bet Payout Failed',
					message: e.adjusted_amount || 'Problem with bet payout',
					timeout: 5
				});
			})
			.finally(() => {
				sending = false;
			});
	}

	function onClose() {
		adjusted_amount = '';
		reviewPayoutBetId.set(false);
	}

	function setAdjustedAmount(amount) {
		adjusted_amount = CurrencyFormat(amount);
	}
</script>

{#if open && bet}
	<Modal on:close={onClose}>
		<h2 slot="header" class="pt-2 text-xl font-bold text-center">Review Bet Payout</h2>
		<div class="flex flex-col w-full px-4 pt-2 text-center">
			<p>
				Bet Ticket #{bet.ticket}
				{#if bet.user && bet.user.pin}for PIN: {bet.user && bet.user.pin}{/if}
			</p>
			<p>
				<span class="font-semibold">Status:</span>
				{bet.status.name}
			</p>
			<div class="flex justify-center space-x-4">
				<span class="font-semibold">Win Limit Rule:</span>
				{bet.win_amount ? CurrencyFormat(bet.win_amount) : '-'}
				<span class="font-semibold">Actual Win Amount:</span>
				{rule && rule.bet_meta ? CurrencyFormat(rule.bet_meta.original_win_amount) : 'N/A'}
			</div>
			<TextInput
				name="adjusted_amount"
				type="number"
				required={true}
				label="New Win Amount"
				className="py-4 w-full text-left font-semibold"
				prefix="$"
				bind:value={adjusted_amount}
				placeholder="Bet Payout Amount"
			/>
			<p class="pb-2 italic text-red-500">Note: The bet will be paid out immediately once saved.</p>
			<LoadingButton on:click={confirmClicked} loading={sending} className="mb-4 btn btn-primary">Save</LoadingButton>
			<button class="mb-4 btn btn-muted" on:click={onClose}>Cancel</button>
		</div>
	</Modal>
{/if}
